(function () {
  const publish = (name, data) => {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(`metal_shop:${name}`, data).catch(() => {});
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `metal_shop_${name}`, ...data });
    if (typeof window.gtag === 'function') {
      window.gtag('event', `metal_shop_${name}`, data);
    }
  };

  const normalize = (value) => String(value || '').trim();
  const isSkuLike = (value) => /^[a-z0-9][a-z0-9._/-]{2,49}$/i.test(normalize(value));

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    if (!form) return;
    const term = normalize(new FormData(form).get('q'));
    if (!term) return;
    publish('search_submitted', {
      search_term: term,
      sku_like: isSkuLike(term),
      source: form.closest('.search-modal') ? 'header' : 'search_page',
    });
  });

  document.addEventListener('click', (event) => {
    const resultLink = event.target.closest(
      'predictive-search a[href*="/products/"], .template-search a[href*="/products/"]',
    );
    if (!resultLink) return;
    const searchInput = document.querySelector('input[type="search"][name="q"]');
    const term = normalize(searchInput?.value);
    publish('search_result_selected', {
      search_term: term,
      sku_like: isSkuLike(term),
      destination: resultLink.getAttribute('href'),
    });
  });

  const params = new URLSearchParams(window.location.search);
  const term = normalize(params.get('q'));
  const summary = document.querySelector('[data-metal-shop-search-results]');
  if (term && summary) {
    const resultCount = Number(summary.dataset.resultCount || 0);
    publish(resultCount === 0 ? 'zero_result_search' : 'search_results_viewed', {
      search_term: term,
      sku_like: isSkuLike(term),
      result_count: resultCount,
    });
  }
})();
